<style>
    .vs-card--content {
        margin-bottom: 0;
    }
    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
    .ql-editor {
        min-height: 150px;
    }
    .ck-editor__editable {
        min-height: 150px;
    }
    .lampiran-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 10px;
    }
    .lampiran-row .file-label {
        font-size: 12px;
        color: #28a745;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>

<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Surat Pesanan</h4>
                    </div>
                    <vs-button
                        color="primary"
                        class="mb-4 mr-1 btn md:mb-0"
                        @click="submitForm"
                        :disabled="data.details.length < 1"
                    >Simpan</vs-button>
                </div>

                <!-- ===== HEADER ===== -->
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/2">
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Obyek</div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.header.obyek" placeholder="Isi obyek pesanan"/>
                            </div>
                        </div>
                        <div class="hidden mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Ekspektasi Selesai</div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.header.ekspektasi_selesai" :config="dateConfig" />
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Selesai Paling Lambat</div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.header.selesai_paling_lambat" :config="dateConfig" />
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/2">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">PKS</div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.header.pks" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Tanggal Pesan</div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.header.tanggal_pesan" :config="dateConfig" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">Nama Regional Head</div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.header.nama_regional_head" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">Email Regional Head</div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.header.email_regional_head" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== TABEL DETIL PESANAN ===== -->
                <div class="mt-8">
                    <h5 class="mb-3">Detil Pesanan</h5>
                    <vs-button @click="addDetail()" class="mr-1 btn" type="border">Tambah</vs-button>
                    <vs-button
                        class="mr-1 btn"
                        @click="removeDetail()"
                        :disabled="selected.length < 1"
                        type="border"
                        color="danger"
                    >Hapus</vs-button>

                    <vs-table v-model="selected" :data="data.details" hoverFlat class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 200px;">Nama Produk</vs-th>
                            <vs-th style="min-width: 180px;">Keterangan</vs-th>
                            <vs-th style="min-width: 90px; width: 90px">Jumlah Pesan</vs-th>
                            <vs-th style="min-width: 90px; width: 90px">Satuan</vs-th>
                            <vs-th style="min-width: 130px; width: 130px">Harga PMT</vs-th>
                            <vs-th style="min-width: 160px; width: 160px">Harga Pengajuan</vs-th>
                            <vs-th style="min-width: 150px; width: 150px">Total Selisih Harga</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="detail" :key="index" v-for="(detail, index) in data">
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.product_id"
                                        width="100%"
                                        autocomplete
                                        @input-change="searchProduct($event)"
                                        @change="onProductChange(detail)"
                                    >
                                        <vs-select-item
                                            v-for="(item, pi) in products"
                                            :key="pi"
                                            :value="item.value"
                                            :text="item.label"
                                        />
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.keterangan" placeholder="Catatan customize"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input
                                        class="w-full"
                                        v-model="detail.jumlah"
                                        type="number"
                                        min="0"
                                        @input="hitungSelisih(detail)"
                                    />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.satuan"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input
                                        class="w-full"
                                        v-model="detail.harga_pmt"
                                        type="number"
                                        min="0"
                                        @input="hitungSelisih(detail)"
                                    />
                                </vs-td>
                                <vs-td>
                                    <vs-input
                                        class="w-full"
                                        v-model="detail.harga_diinginkan"
                                        type="number"
                                        min="0"
                                        @input="hitungSelisih(detail)"
                                    />
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="detail.total_selisih" :disabled="true"/>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>

                <!-- ===== LAMPIRAN ===== -->
                <div class="mt-8">
                    <h5 class="mb-3">Lampiran Dokumen</h5>
                    <div
                        v-for="(file, fi) in data.lampiran"
                        :key="fi"
                        class="lampiran-row"
                    >
                        <vs-select
                            v-model="file.jenis"
                            width="160px"
                            class="selectExample"
                        >
                            <vs-select-item
                                v-for="(j, ji) in jenisFile"
                                :key="ji"
                                :value="j.value"
                                :text="j.label"
                            />
                        </vs-select>
                        <input
                            type="file"
                            @change="onFileChange($event, fi)"
                            style="flex: 1; padding: 4px 0; font-size: 13px;"
                        />
                        <span v-if="file.nama" class="file-label">{{ file.nama }}</span>
                        <vs-button
                            color="danger"
                            type="border"
                            icon="delete"
                            size="small"
                            @click="removeLampiran(fi)"
                        ></vs-button>
                    </div>
                    <vs-button type="border" class="mt-2" @click="addLampiran()">
                        + Tambah Lampiran
                    </vs-button>
                </div>

                <!-- ===== CATATAN (WYSIWYG) ===== -->
                <div class="mt-8 mb-6">
                    <h5 class="mb-3">Catatan</h5>
                    <vs-input class="w-full" v-model="data.header.obyek" placeholder="Isi obyek pesanan"/>
                </div>

                <!-- ===== CATATAN2 (WYSIWYG CKEditor) ===== -->
                <div class="mt-8 mb-6">
                    <h5 class="mb-3">Catatan</h5>
                    <!-- <ckeditor :editor="editor" v-model="data.catatan2" :config="editorConfig" /> -->
                </div>


                <!-- ===== LAMPIRAN ===== -->
                <div class="mt-8">
                    <h5 class="mb-3">Tembusan</h5>
                     <div
                        v-for="(file, fi) in data.tembusan2"
                        :key="fi"
                        class="lampiran-row"
                    >                   
                    <vs-select
                            v-model="file.jenis"
                            width="160px"
                            class="selectExample"
                        >
                        <vs-select-item
                            v-for="(j, ji) in tembusan2"
                            :key="ji"
                            :value="j.value"
                            :text="j.label"
                            />
                        </vs-select>
                        <vs-button
                            color="danger"
                            type="border"
                            icon="delete"
                            size="small"
                            @click="removeTembusan(fi)"
                        ></vs-button>
                    </div>
                    <vs-button type="border" class="mt-2" @click="addTembusan()">
                        + Tambah Tembusan
                    </vs-button>
                </div>

            </vs-card>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    // import CKEditor from '@ckeditor/ckeditor5-vue2'
    // import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

    export default {
        components: {
            flatPickr,
            vSelect,
            // ckeditor: CKEditor.component,
        },
        data() {
            return {
                /* HJR WYSIWYG
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [
                        'heading', '|',
                        'bold', 'italic', 'underline', 'strikethrough', '|',
                        'bulletedList', 'numberedList', '|',
                        'outdent', 'indent', '|',
                        'link', 'blockQuote', 'insertTable', 'mediaEmbed', '|',
                        'undo', 'redo',
                    ],
                    placeholder: 'Tulis catatan di sini...',
                },*/
                selected: [],
                isLoading: false,
                products: [
                    { value: 'gambar', label: 'Bantingan (Thresher)' },
                    { value: 'dokumen', label: 'Hydrocyclone' },
                    { value: 'spreadsheet', label: 'Cake Breaker Conveyor (CBC)' },
                    { value: 'pdf', label: 'Lori Buah' },
                    { value: 'video', label: 'Polishing Drum' },
                    { value: 'lainnya', label: 'LTDS (Light Tenera Dust Separator)' },],
                tembusanOptions: [],
                dateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                },
                tembusan2: [
                    { value: 'gambar', label: '2AKN' },
                    { value: 'dokumen', label: '3KGO' },
                    { value: 'dokumen2', label: 'Pertinggal' },
                ],
                jenisFile: [
                    { value: 'gambar', label: 'Anggaran' },
                    { value: 'dokumen', label: 'Lainnya' },
                ],
                editorOptions: {
                    theme: 'snow',
                    placeholder: 'Tulis catatan di sini...',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote'],
                            [{ header: 1 }, { header: 2 }],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ indent: '-1' }, { indent: '+1' }],
                            [{ color: [] }, { background: [] }],
                            ['link'],
                            ['clean'],
                        ],
                    },
                },
                data: {
                    header: {
                        pks: 'SEI GARO',
                        tanggal_pesan: '2025-09-20', // new Date().toISOString().slice(0, 10),
                        obyek: 'PENGADAAN DAN PEMBUATAN BARU LORI REBUSAN 2,5 TON 10 (SEPULUH) UNIT',
                        ekspektasi_selesai: null,
                        selesai_paling_lambat: '2025-12-07',
                        nama_regional_head: 'Ahmad Gusmar Harahap',
                        email_regional_head: 'ahmadgusmar.harahap@ptpn4.co.id',
                    },
                    details: [],
                    catatan: '',
                    catatan2: '',
                    lampiran: [],
                    tembusan: [],
                    tembusan2: [
                    { value: 'gambar', label: '2AKN' },
                    { value: 'dokumen', label: '3KGO' },
                    { value: 'dokumen2', label: 'Pertinggal' },
                ],
                },
            }
        },
        watch: {
            isLoading(val) {
                if (val) this.$vs.loading()
                else this.$vs.loading.close()
            },
        },
        methods: {
            submitForm() {

                if (!this.data.header.obyek) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Validasi Gagal',
                        iconPack: 'feather',
                        icon: 'icon-x',
                        text: 'Obyek tidak boleh kosong',
                    })
                    return
                }

                for (let i = 0; i < this.data.details.length; i++) {
                    const d = this.data.details[i]
                    if (!d.product_id || !d.jumlah || d.jumlah <= 0) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Validasi Gagal',
                            iconPack: 'feather',
                            icon: 'icon-x',
                            text: `Periksa baris ke-${d.line_id}: nama produk dan jumlah wajib diisi`,
                        })
                        return
                    }
                }

                const formData = new FormData()
                formData.append('header', JSON.stringify(this.data.header))
                formData.append('details', JSON.stringify(this.data.details))
                formData.append('catatan', this.data.catatan)
                formData.append('catatan2', this.data.catatan2)
                formData.append('tembusan', JSON.stringify(this.data.tembusan))

                this.data.lampiran.forEach((item, index) => {
                    if (item.file) {
                        formData.append(`lampiran[${index}][jenis]`, item.jenis)
                        formData.append(`lampiran[${index}][file]`, item.file)
                    }
                })

                this.isLoading = true
                this.$http.post('surat-pesanan/store', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Berhasil Disimpan',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        text: 'Surat pesanan berhasil dibuat',
                    })
                    this.$router.push({ name: 'surat-pesanan' })
                })
                .catch(error => this.handleError(error))
            },
            back() {
                this.$router.push({ name: 'surat-pesanan' })
            },
            addDetail() {
                this.data.details.push({
                    line_id: this.data.details.length + 1,
                    product_id: 'gambar',
                    product_name: 'Bantingan (Thresher)',
                    keterangan: 'Penyesuaian budget',
                    jumlah: '2',
                    satuan: 'PCS',
                    harga_pmt: '200000000',
                    harga_diinginkan: '150000000',
                    total_selisih: '50.000.000',
                })
            },
            removeDetail() {
                const indexes = []
                this.selected.forEach(sel => {
                    this.data.details.forEach((d, idx) => {
                        if (sel.line_id === d.line_id) indexes.push(idx)
                    })
                })
                indexes.sort((a, b) => b - a)
                indexes.forEach(i => this.data.details.splice(i, 1))
                this.selected = []
                this.data.details.forEach((d, i) => { d.line_id = i + 1 })
            },
            hitungSelisih(detail) {
                const jumlah = parseFloat(detail.jumlah) || 0
                const hargaPmt = parseFloat(detail.harga_pmt) || 0
                const hargaDiinginkan = parseFloat(detail.harga_diinginkan) || 0
                detail.total_selisih = ((hargaPmt - hargaDiinginkan) * jumlah).toFixed(2)
            },
            onProductChange(detail) {
                const found = this.products.find(p => p.id === detail.product_id)
                if (found) {
                    detail.product_name = found.name
                    detail.satuan = found.satuan || ''
                    detail.harga_pmt = found.harga_pmt || ''
                }
            },
            searchProduct(e) {
                const keyword = e && e.target ? e.target.value : (e || '')
                this.$http.post('master/product/search', { keyword })
                .then(res => {
                    this.products = res.data.data || []
                })
                .catch(() => {})
            },
            addTembusan() {
                this.data.tembusan2.push({ tembusan2: null, nama: '' })
            },
            removeTembusan(index) {
                this.data.tembusan2.splice(index, 1)
            },
            addLampiran() {
                this.data.lampiran.push({ jenis: 'dokumen', file: null, nama: '' })
            },
            removeLampiran(index) {
                this.data.lampiran.splice(index, 1)
            },
            onFileChange(event, index) {
                const file = event.target.files[0]
                if (file) {
                    this.data.lampiran[index].file = file
                    this.data.lampiran[index].nama = file.name
                }
            },
            searchTembusan(e) {
                const keyword = e && e.target ? e.target.value : (e || '')
                this.$http.post('master/users/search', { keyword })
                .then(res => {
                    this.tembusanOptions = res.data.data || []
                })
                .catch(() => {})
            },
            fetchTembusan() {
                this.$http.post('master/users/search', { keyword: '' })
                .then(res => {
                    this.tembusanOptions = res.data.data || []
                })
                .catch(() => {})
            },
        },
        mounted() {
        },
    }
</script>
